import {
  ScopeOfPracticeEnum,
  ShiftStatusEnum,
  ShiftTypeEnum
} from '@umss/shared/utils';

/**
 * DTO for searching available shift needs from contractor perspective
 * Matches backend ShiftSearchDto with contractor-specific fields
 */
export interface ShiftNeedSearchDto {
  // Contractor context
  contractorId?: string;

  // Filters
  facilityId?: string;
  facilityIds?: string[];
  scopesOfPractice?: ScopeOfPracticeEnum[];
  statuses?: ShiftStatusEnum[];
  shiftTypes?: ShiftTypeEnum[];
  startDate?: string; // ISO date format YYYY-MM-DD
  endDate?: string; // ISO date format YYYY-MM-DD
  minHourlyRate?: number;
  maxHourlyRate?: number;

  // Search
  searchTerm?: string; // Search facility name, shift details

  // Pagination
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortDescending?: boolean;

  // Location-based search (supported by backend)
  contractorIdForDistance?: string; // Contractor ID to calculate distance from
  maxDistanceMiles?: number; // Maximum distance in miles (1-500)
  latitude?: number; // Alternative to contractorIdForDistance
  longitude?: number; // Alternative to contractorIdForDistance
  sortByDistance?: boolean; // Sort results by distance (closest first)

  // Backend-side exclusion filters
  excludeExpired?: boolean; // Exclude shift needs where expiresAt has passed
  excludeConflictsForContractor?: boolean; // Exclude shifts that conflict with contractor's confirmed shifts
  excludeStarted?: boolean; // Exclude shifts whose start time has already passed
}
